import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { journeys } from "@/mocks/events";

export default function JourneysSection() {
  const featured = journeys.slice(0, 4);

  return (
    <section className="relative overflow-hidden bg-foreground-950 text-background-50 grain">
      <div className="w-full px-5 md:px-10 lg:px-16 py-20 md:py-28">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <Reveal>
              <p className="eyebrow text-primary-400">
                Section 03 — The Travel
              </p>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="mt-5 font-heading text-4xl leading-[1.02] sm:text-5xl md:text-6xl lg:text-7xl">
                CULINARY
                <br />
                <span className="italic text-primary-400">JOURNEYS</span>
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 lg:self-end">
            <Reveal delay={200}>
              <p className="font-body text-base leading-relaxed text-background-50/70 md:text-lg">
                Follow Chef Eddie & Kiki G as food, culture and curiosity take
                them around the world. A living travel journal of culinary
                experiences, chef journeys and locavore adventures.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 border-t border-background-50/15">
          {featured.map((journey, i) => (
            <Reveal key={journey.slug} delay={i * 90}>
              <Link
                to={`/culinary-journeys/${journey.slug}`}
                className="group grid grid-cols-1 items-center gap-5 border-b border-background-50/15 py-6 transition-colors duration-500 md:grid-cols-12 md:gap-8"
              >
                <div className="md:col-span-2">
                  <div className="h-32 w-full overflow-hidden bg-foreground-900 md:h-24 md:w-24">
                    <img
                      src={journey.image}
                      alt={`${journey.city} culinary journey`}
                      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                  </div>
                </div>

                <div className="md:col-span-2">
                  <div className="font-label text-[11px] uppercase tracking-label text-primary-400">
                    {journey.dateLabel}
                  </div>
                  <div className="mt-1 font-body text-xs text-background-50/50">
                    {journey.region}
                  </div>
                </div>

                <div className="md:col-span-5">
                  <h3 className="font-heading text-2xl leading-tight transition-transform duration-500 group-hover:translate-x-2 md:text-3xl">
                    {journey.city}
                  </h3>
                  <p className="mt-1 font-body text-sm text-background-50/60">
                    {journey.title}
                  </p>
                </div>

                <div className="md:col-span-2">
                  <span className="inline-block rounded-full border border-background-50/25 px-3 py-1 font-label text-[10px] uppercase tracking-label text-background-50/75">
                    {journey.category}
                  </span>
                </div>

                <div className="md:col-span-1 md:justify-self-end">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full border border-background-50/25 transition-all duration-500 group-hover:border-primary-500 group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className="ri-arrow-right-line text-lg" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal delay={200}>
          <Link
            to="/culinary-journeys"
            className="link-underline mt-10 inline-flex w-fit items-center gap-2 font-label text-[11px] uppercase tracking-label text-primary-400"
          >
            View the full calendar
            <i className="ri-arrow-right-line text-base" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}